/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Phase_3_Task_3_Day_StreakInputs */

const en_phase_3_task_3_day_streak = /** @type {(inputs: Phase_3_Task_3_Day_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Focus for 3 Days in a Row`)
};

const ar_phase_3_task_3_day_streak = /** @type {(inputs: Phase_3_Task_3_Day_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التركيز لمدة 3 أيام متتالية`)
};

const de_phase_3_task_3_day_streak = /** @type {(inputs: Phase_3_Task_3_Day_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fokus für 3 Tage in Folge`)
};

const es_phase_3_task_3_day_streak = /** @type {(inputs: Phase_3_Task_3_Day_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concéntrate durante 3 días seguidos`)
};

const fr_phase_3_task_3_day_streak = /** @type {(inputs: Phase_3_Task_3_Day_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se concentrer pendant 3 jours consécutifs`)
};

const it_phase_3_task_3_day_streak = /** @type {(inputs: Phase_3_Task_3_Day_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concentrati per 3 giorni di fila`)
};

const ja_phase_3_task_3_day_streak = /** @type {(inputs: Phase_3_Task_3_Day_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3日連続で集中`)
};

const ko_phase_3_task_3_day_streak = /** @type {(inputs: Phase_3_Task_3_Day_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3일 연속 집중하기`)
};

const pt_br_phase_3_task_3_day_streak = /** @type {(inputs: Phase_3_Task_3_Day_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantenha o foco por 3 dias seguidos`)
};

const ru_phase_3_task_3_day_streak = /** @type {(inputs: Phase_3_Task_3_Day_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сосредотачивайтесь в течение 3 дней подряд`)
};

const th_phase_3_task_3_day_streak = /** @type {(inputs: Phase_3_Task_3_Day_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โฟกัสต่อเนื่อง 3 วันติด`)
};

const tr_phase_3_task_3_day_streak = /** @type {(inputs: Phase_3_Task_3_Day_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 Gün Üst Üste Odaklan`)
};

const zh_cn_phase_3_task_3_day_streak = /** @type {(inputs: Phase_3_Task_3_Day_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`连续专注 3 天`)
};

const zh_tw_phase_3_task_3_day_streak = /** @type {(inputs: Phase_3_Task_3_Day_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`連續專注 3 天`)
};

/**
* | output |
* | --- |
* | "Focus for 3 Days in a Row" |
*
* @param {Phase_3_Task_3_Day_StreakInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const phase_3_task_3_day_streak = /** @type {((inputs?: Phase_3_Task_3_Day_StreakInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phase_3_Task_3_Day_StreakInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_phase_3_task_3_day_streak(inputs)
	if (locale === "ar") return ar_phase_3_task_3_day_streak(inputs)
	if (locale === "de") return de_phase_3_task_3_day_streak(inputs)
	if (locale === "es") return es_phase_3_task_3_day_streak(inputs)
	if (locale === "fr") return fr_phase_3_task_3_day_streak(inputs)
	if (locale === "it") return it_phase_3_task_3_day_streak(inputs)
	if (locale === "ja") return ja_phase_3_task_3_day_streak(inputs)
	if (locale === "ko") return ko_phase_3_task_3_day_streak(inputs)
	if (locale === "pt_br") return pt_br_phase_3_task_3_day_streak(inputs)
	if (locale === "ru") return ru_phase_3_task_3_day_streak(inputs)
	if (locale === "th") return th_phase_3_task_3_day_streak(inputs)
	if (locale === "tr") return tr_phase_3_task_3_day_streak(inputs)
	if (locale === "zh_cn") return zh_cn_phase_3_task_3_day_streak(inputs)
	return zh_tw_phase_3_task_3_day_streak(inputs)
});